import { AlertTriangle, Clock3 } from 'lucide-react';
import { RiskAction } from '../types';

interface RiskActionQueueProps {
  actions: RiskAction[];
}

const tone = {
  high: 'border-rose-500/30 bg-rose-500/10 text-rose-200',
  medium: 'border-amber-500/30 bg-amber-500/10 text-amber-200',
  low: 'border-emerald-500/30 bg-emerald-500/10 text-emerald-200'
} as const;

const RiskActionQueue = (props: RiskActionQueueProps) => {
  const { actions } = props;

  return (
    <div className="rounded-[2rem] border border-slate-700/60 bg-slate-900 p-6">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-2xl bg-amber-500/10 border border-amber-500/30 flex items-center justify-center">
          <Clock3 size={16} className="text-amber-300" />
        </div>
        <div>
          <h3 className="text-[10px] font-black uppercase tracking-[0.2em] text-slate-400">Action Queue</h3>
          <p className="text-xs text-slate-500 mt-2">Operational priorities, not abstract theory. These are the next moves the owner should probably make.</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {actions.length ? actions.map((action) => (
          <div key={action.id} className={`rounded-2xl border p-4 ${tone[action.priority]}`}>
            <div className="flex items-center justify-between gap-3 mb-3">
              <p className="text-[10px] font-black uppercase tracking-widest">{action.priority} priority</p>
              <AlertTriangle size={14} />
            </div>
            <p className="text-sm font-black text-white">{action.title}</p>
            <p className="text-sm mt-2 leading-relaxed text-slate-300">{action.detail}</p>
          </div>
        )) : (
          <div className="rounded-2xl border border-slate-700/70 bg-slate-950/60 p-4 md:col-span-2">
            <p className="text-sm text-slate-300">No urgent actions are currently flagged. Continue updating the risk profile as conditions, reserves, and turnover assumptions change.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default RiskActionQueue;
